import axios from 'axios';

const removeManualCoop = async (body: { userId: string; orgId: string }) => {
  await axios.post('/supra_system/subscription/remove_manual_coop', body);
};

export default removeManualCoop;
